import SongIcon from './component.jsx'
export default SongIcon
